import { render } from "./currency-dropdown.vue?vue&type=template&id=7d10c3f2"
import script from "./currency-dropdown.vue?vue&type=script&lang=js"
export * from "./currency-dropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__